import axios from 'axios'
import {NOTIFICATION_DANGER} from "../../constants/common";
// initial state
const state = {
    loading : false,
    currentStep: 1,
    lists: [],
    test:[],
    answers: [],
    testAnswers: [],
    questionnairePassed: false,
    testPassed: false
};

// getters
const getters = {
    getAnswerById: state => id =>  {
        let ans = state.answers.find(x => x.questionId === id);
        return ans ? ans.value : ''
    }
};

// actions
const actions = {
    getQuestions({commit}) {
        commit('setLoading', true);
        //todo: для симуляции загрузки, потом удалить
        setTimeout(() => {
            axios.get('/api/questionnaire.json')
                .then((response) => {
                    commit('setLists', response.data.lists);
                    commit('setAnswers', response.data.answers);
                    commit('setLoading', false);
                })
                .catch((response) => {
                    console.log(response);
                    this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                });
        },1000);
    },
    getTestQuestions({commit}) {
        commit('setLoading', true);
        //todo: для симуляции загрузки, потом удалить
        setTimeout(() => {
            axios.get('/api/test.json')
                .then((response) => {
                    commit('setTestLists', response.data.lists);
                    commit('setTestAnswers', response.data.answers);
                    commit('setLoading', false);
                })
                .catch((response) => {
                    console.log(response);
                    this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                });
        },1000);
    },
    sendData({commit}) {
        commit('setLoading', true);
        return new Promise((resolve) => {
            //todo: для симуляции загрузки, потом удалить
            setTimeout(() => {
                axios.get('/api/test.json')
                    .then(() => {
                        //commit('setTestLists', response.data.lists);
                        commit('setLoading', false);
                    })
                    .catch((response) => {
                        console.log(response);
                        this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Server error", time: 10000})
                    });
                resolve()

            }, 1000)
        });
    }
};

// mutations
const mutations = {
    setStep (state, value) {
        if (value < 1) {
            value = 1;
        }
        if (value > state.steps) {
            value = state.steps
        }
        state.currentStep = value
    },
    setLists (state, array) {
        state.lists = array
    },
    setTestLists (state, array) {
        state.test = array
    },
    setAnswers (state, array) {
        state.answers = array
    },
    setTestAnswers (state, array) {
        state.testAnswers = array
    },
    setAnswerValue (state, {id, value}) {
        let index = state.answers.findIndex(x => x.questionId === id);
        if (index < 0) {
            state.answers.push({questionId: id, value:value})
        } else {
            let ans = state.answers[index];
            ans.value = value;
            state.answers.splice(index, 1, ans);
        }

    },
    setGroup(state, {idGroup, group}) {
        state.lists[state.currentStep -1].groups[idGroup] = group
    },
    setQuestionnairePassed (state) {
        state.questionnairePassed = true
    },
    setTestPassed (state) {
        state.testPassed = true
    },
    setLoading(state, value) {
        state.loading = value;
    },

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}